import React, { Component } from 'react';

class CurrrentPosLabel extends Component {

  _renderRegionTxt = (locTxt) => {
    return (
      <div className="region-seach layer-pop-open" style={this.props.marginTop} data-type="region" onClick={this.props.onClick}>
        <a href={null} data-type="region" onClick={this.props.onClick}>지역 검색 위치는 <strong data-type="region" onClick={this.props.onClick}>"{locTxt}"</strong> 입니다.</a>
      </div>
    )
  }

  render() {
    var _locTxt = '';
    if(!this.props.selSido) {
      _locTxt = '전 지역';
    } else if(!this.props.selSigungu) {
      _locTxt = this.props.selSido + ' 전 지역';
    } else if(!this.props.selDong) {
      _locTxt = this.props.selSido + ' ' + this.props.selSigungu + ' 전 지역';
    } else {
      _locTxt = this.props.selSido + ' ' + this.props.selSigungu + ' ' + this.props.selDong;
    }

    if(this.props.searchType === 'distance') {
      if(this.props.currSido) {
        return (
          <div>
            <div className="cur-posi">
              <p className="btxt">현 위치는 <strong>“{this.props.currSido} {this.props.currSigungu} {this.props.currDong}”</strong> 입니다.</p>
              {this._renderRegionTxt(_locTxt)}
            </div>
          </div>
        )
      } else {
        return (
          <div></div>
        )
      }
    } else {
      return this._renderRegionTxt(_locTxt)
    }
  }
}

export default CurrrentPosLabel;